import { render, staticRenderFns } from "./SharePropertyComponent.vue?vue&type=template&id=1b4cdcfa"
import script from "./SharePropertyComponent.vue?vue&type=script&lang=js"
export * from "./SharePropertyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports